import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Statement.CreateForDealer.IRequest;
type Response = Api.Core.Statement.CreateForDealer.IResponse;
type Headers = Api.Core.Statement.CreateForDealer.IHeaders;
const url = '/api/DealerManagement/Statement/ForDealer';
export default async function statementCreateForDealerApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
